export default __webpack_public_path__ + "static/media/AelfrithCamp.ddc55de2.jpg";